import {createRouter, createWebHistory} from 'vue-router'
import {siteRoutes} from "@moeinmdn/miw-router/src/package/routes/SiteRoutes";
import {overWriteRoute, findRoutes} from '@moeinmdn/miw-router/src/package/RouterFunctions'
import multiguard from "vue-router-multiguard";
import {loginRequired} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";

import HomeView from '../views/HomeView.vue'
import Login from "@/views/Login.vue";
import SiteLayout from "@/views/SiteLayout.vue";

overWriteRoute(siteRoutes, 'Home', {components: {site: HomeView}})
overWriteRoute(siteRoutes, 'Login', {components: {site: Login}})
overWriteRoute(siteRoutes, 'SiteLayout', {component:SiteLayout})

const routes = [
    ...siteRoutes,
    {
        path: '/',
        name: 'Home',
        component: HomeView,
        beforeEnter: multiguard([loginRequired]),
    },
]

export let defaultLanguage = 'fa'
export let languages = ['fa', 'en',]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


export function addRoute(route) {
    // Check if the route with the same path already exists
    if (!router.options.routes.some(existingRoute => existingRoute.path === route.path)) {
        // Add the route to the routes array
        router.addRoute(route)
    }
}

export function removeRoute(routeName) {
    router.removeRoute(routeName)
}


export default router
